import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { type ProgressGlowProps } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/speed-key-messages/progress-glow/types';
import styles from '@/app/lcv/components/sections/spartan/engine/styles.module.css';
import { cn } from '@/app/utils/cn';
export const ProgressGlow = t0 => {
  const $ = _c(25);
  const {
    isFilled,
    className,
    children
  } = t0;
  const id = useId();
  const blurId = `${id}-blur`;
  const fillId = `${id}-fill`;
  let t1;
  if ($[0] !== className || $[1] !== isFilled) {
    t1 = cn(styles.speedIndicator, styles.speedGlow, {
      [styles.active]: isFilled
    }, className);
    $[0] = className;
    $[1] = isFilled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <feGaussianBlur stdDeviation="12" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== blurId) {
    t3 = <filter id={blurId} x="0" y="0" width="208" height="172" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">{t2}</filter>;
    $[4] = blurId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <stop stopColor="#48B3FF" stopOpacity="0.7" />;
    t5 = <stop offset="1" stopColor="#48B3FF" stopOpacity="0.1" />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== fillId) {
    t6 = <linearGradient id={fillId} x1="104" y1="24" x2="104" y2="148" gradientUnits="userSpaceOnUse">{t4}{t5}</linearGradient>;
    $[8] = fillId;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t6) {
    t7 = <defs>{t3}{t6}</defs>;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `url(#${fillId})`;
  const t9 = `url(#${blurId})`;
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <path d="M104 24C148.183 24 184 59.8172 184 104C184 120.254 179.153 135.377 170.824 148H37.1758C28.8474 135.377 24 120.254 24 104C24 59.8172 59.8172 24 104 24Z" fill={t8} fillOpacity="0.6" filter={t9} />;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t7) {
    t11 = <div aria-hidden={true} className={styles.speedIndicatorArt}><svg viewBox="0 0 208 172" fill="none" className="block size-full overflow-visible">{t7}{t10}</svg></div>;
    $[16] = t10;
    $[17] = t7;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== children) {
    t12 = <div className={styles.speedIndicatorContent}>{children}</div>;
    $[19] = children;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t1 || $[22] !== t11 || $[23] !== t12) {
    t13 = <div className={t1}>{t11}{t12}</div>;
    $[21] = t1;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};